import { modelContainsIncludes, expired, reduce } from "../Helpers";
import ObjectHelper from "../../helpers/ObjectHelper";

const baseModule = {
    namespaced: true,

    state() {
        return {
            all: {},

            pagination: {
                last_page: 0,
                path: '',
                per_page: 10,
                total: 0
            },

            searchPagination: {
                last_page: 0,
                path: '',
                per_page: 10,
                total: 0
            },

            endpoints: {
                all: '',
                fieldIsUnique: 'fieldIsUnique',
                search: 'search',
                update: 'update'
            },

            enums: {},

            primaryKey: 'id',

            moduleBindings: {},

            ignore: [
                'pagination',
                'includes',
                'cache',
                'translations',
                'pivot'
            ],

            invalidUniqueFields: []
        }
    },

    mutations: {
            set(state, data) {

            if(!data.attributes)
                return;

            let objectData = data.attributes;
            objectData.id = data.id;

            let current = state.all[objectData.id];

            if (current !== undefined && current !== null) {
                let currentCopy = ObjectHelper.cleanClone(current);
                let dataCopy = ObjectHelper.cleanClone(objectData);

                delete currentCopy.dirty;
                delete dataCopy.dirty;
                delete currentCopy.cache;
                delete dataCopy.cache;

                if (ObjectHelper.compareObjects(dataCopy, currentCopy)) {
                    return;
                }

                objectData.dirty = true;
            } else {
                objectData.dirty = false;
            }

            state.all[objectData.id] = objectData;
        },

        addInvalidUniqueField(state, field) {
            state.invalidUniqueFields[state.invalidUniqueFields.length] = field;
        },

        resetInvalidUniqueFields(state) {
            state.invalidUniqueFields = [];
        },

        delete(state, id) {
            delete state.all.id;
        },

        pagination(state, data) {
            state.pagination = {...data};
        },

        searchPagination(state, data) {
            state.searchPagination = {...data};
        },

        all(state, date) {
            state.all = data;
        },

        allClean(state, getters) {
            return getters['pagination'].total === getters['allValues'].length && getters['allValues'].filter(elem => elem.dirty === false).length === getters['pagination'].total;
        },

        clearSearchPagination(state) {
            stat.searchPagination = {
                last_page: 0,
                path: '',
                per_page: 10,
                total: 0
            };
        },

        setRelationData(state, data) {
            if (state.all[data.localId].relationships === undefined) {
                state.all[data.localId].relationships = {};
            }

            if (state.all[data.localId].relationships[data.relationship] === undefined) {
                state.all[data.localId].relationships[data.relationship] = [ data.relatedObject ];

            } else if (Array.isArray(state.all[data.localId].relationships[data.relationship])) {
                state.all[data.localId].relationships[data.relationship].push(
                    data.relatedObject
                );

            }

        }
    },

    getters: {
        exists(state) {
            return function (primaryKey) {
                return state.all.hasOwnProperty(primaryKey);
            }
        },

        get(state) {
            return function (id) {
                return state.all[id];
            }
        },

        endpoints(state) {
            return function(key) {
                return state.endpoints[key];
            }
        },

        all(state) {
            return state.all;
        },

        allValues(state) {
            return Object.values(state.all);
        },

        byName(state, getters) {
            return function(name) {
                return getters['allValues'].find(function (element) {
                    return element.name.toLowerCase() === name.toLowerCase();
                });
            }
        },

        invalidUniqueFields(state) {
            return state.invalidUniqueFields;
        },

        modelUrl(state, getters) {
            return function(id) {
                return getters['endpoints']('all') + '/' + id;
            }
        },

        pagination(state) {
            return state.pagination;
        },

        searchPagination(state) {
            return state.searchPagination;
        },

        page(state) {
            return function(pageNumber) {
                return Object.values(state.all).filter(function (element) {
                    return ![null, undefined].includes(element)
                        && element.hasOwnProperty('pagination')
                        && element.pagination.hasOwnProperty('page')
                        && element.pagination.page === pageNumber;
                }).sort((a, b) => b.position - a.position)
            }
        },

        primaryKey(state) {
            return state.primaryKey;
        },

        allClean(state, getters) {
            return getters['allValues'].every(elem => elem.dirty === false);
        },

        pageClean(state, getters) {
            return function(page) {
                return getters['page'](page).every(elem => elem.dirty === false);
            }
        },

        allLocal(state, getters) {
            return getters['allValues'].length === getters['pagination'].total;
        },

        allIncludes(state, getters) {
            return function(includes) {
                return getters['allValues'].every(elem => {
                    if (!elem.hasOwnProperty('includes')) { return false; }
                    if (includes.length === 0) { return true; }
                    return includes.every(include => elem.includes.includes(include));
                })
            }
        },

        pageIncludes(state, getters) {
            return function(page, includes) {
                return getters['page'](page).every(elem => {
                    if (!elem.hasOwnProperty('includes')) { return false; }
                    if (includes.length === 0) { return true; }
                    return includes.every(include => elem.includes.includes(include));
                })
            }
        },

        empty(state, getters) {
            return getters['allValues'].length === 0;
        }
    },

    actions: {
        async clearAll({ commit, dispatch, getters, state, rootGetters }) {
            state.all = {};
        },
        async getAll({ commit, dispatch, getters, state, rootGetters }, data = {}) {

            let params = {};
            params.page = -1;

            let endpoint = getters['endpoints']('all');

            if (data.hasOwnProperty('endpoint')) {
                endpoint = data.endpoint;
            }

            if (data.hasOwnProperty('page')) {
                params.page = data.page;
            }

            if (data.hasOwnProperty('includes')) {
                params.includes = data.includes;
            }

            if (data.hasOwnProperty('fieldset')) {
                params.fieldset = data.fieldset;
            }

            if (data.hasOwnProperty('filters')) {
                for (let filter in data.filters) {
                    if (data.filters.hasOwnProperty(filter)) {
                        params["filter["+filter+"]"] = data.filters[filter];
                }
                }
            }

            let response = await this.axios.get(endpoint, {
                params
            });

            if (response.status === 200) {
                if (
                    response.data.meta != undefined
                    && response.data.meta.pagination != undefined
                ) {
                    commit('pagination', response.data.meta.pagination);
                }


                if (response.data.included != undefined) {
                    for (let i = 0; i < response.data.included.length; i++) {
                        let relatedObject = response.data.included[i];
                        let relatedObjectModule = rootGetters.typeBindings[relatedObject.type]

                        if (relatedObjectModule != undefined) {
                            await commit(
                                relatedObjectModule + '/set',
                                response.data.included[i],
                                { root: true }
                            );
                        }
                    }
                }

                for (let i = 0; i < response.data.data.length; i++) {

                    await dispatch('set', response.data.data[i]);
                }


                return true;
            }

            return false;
        },

        async get({ commit, dispatch, getters, state, rootGetters }, data) {

            let id;
            let includes = [];

            if (typeof data == 'string' || typeof data == 'number') {
                id = data;
            } else if (data.hasOwnProperty(state.primaryKey)) {
                id = data[state.primaryKey];

                if (data.hasOwnProperty('includes')) {
                    includes = data.includes;
                }
            } else {
                return false;
            }

            // check state.all to see if model is saved locally
            if (getters['exists'](id)) {
                if (modelContainsIncludes(getters['get'](id), includes) && !expired(getters['get'](id))) {
                    return getters['get'](id);
                }
            }

            // either:
            // - does not exist locally
            // - does not contain the necessary includes
            // - has expired
            let response = await this.axios.get(getters['endpoints']('all') + '/' + id, {
                params: {
                    includes: includes
                }
            });

            if (response.status === 200) {
                if (response.data.included != undefined) {
                    for (let i = 0; i < response.data.included.length; i++) {
                        let relatedObject = response.data.included[i];
                        let relatedObjectModule = rootGetters.typeBindings[relatedObject.type]
                        if (relatedObjectModule != undefined) {
                            await commit(
                                relatedObjectModule + '/set',
                                response.data.included[i],
                                { root: true }
                            );
                        }
                    }
                }
                let model = response.data.data;
                await dispatch('set', model);
                return true;
            }

            return false;
        },

        async set({dispatch, commit, state, rootGetters, rootState}, data) {

            await commit('set', data);

            if (data.hasOwnProperty('relationships')) {
                for (let relationship in data.relationships) {
                    if (data.relationships.hasOwnProperty(relationship)) {

                        let relationData = data.relationships[relationship];
                        for (let i = 0; i < relationData.length; i++) {
                            let relatedObjectModule = rootGetters.typeBindings[relationData[i].type]

                            await commit('setRelationData', {
                                localId: data.id,
                                relatedObject: rootState[relatedObjectModule]['all'][relationData[i].id],
                                relationship,
                                relatedId: relationData[i].id
                            });
                        }
                    }
                }
            }

        },

        async update({ dispatch, getters, state}, data) {
            let endpoint = getters['modelUrl'](data[state.primaryKey]);

            if (data.includes) {
                data.includes = data.includes.join(',');
            }

            let response = await this.axios.put(endpoint, data);

            if (response.status === 200) {
                return await dispatch('set', response.data);
            }

            return false;
        },

        async update2({ dispatch, commit, getters }, data) {
            let response = await this.axios.put(getters['endpoints']('update'), data);

            if (response.status === 200) {
                return await dispatch('set', response.data);
            }

            return false;
        },

        async create({ dispatch, getters, state}, data) {
            let endpoint = getters['endpoints']('all');

            if (data.includes) {
                data.includes = data.includes.join(',');
            }

            let response = await this.axios.post(endpoint, data);

            if (response.status === 201) {
                return await dispatch('set', response.data);
            }

            return false;
        },

        async delete({commit, getters, state}, id) {
            let endpoint = getters['modelUrl'](id);
            let response = await this.axios.delete(endpoint);

            if (response.status === 200 || response.status === 409) {
                commit('delete', id);
                return true;
            }

            return false;
        },

        async fieldIsUnique({commit, state, getters}, data) {
            let response = await this.axios.post(getters['endpoints']('all') + '/' + getters['endpoints']('fieldIsUnique'), data);

            return response.status === 200;
        },

        async refresh({ dispatch, commit, state }, data) {
            commit('delete', data[state.primaryKey]);
            return await dispatch('get', data);
        },

        async byName({ dispatch, commit, getters }, name) {
            if (getters['byName'](name) === undefined) {
                await dispatch('getAll', { page: -1 });
            }

            return getters['byName'](name);
        },

        async search({ dispatch, commit, getters }, { term, includes, page, perPage = 10 }) {
            let response = await this.axios.get(getters['endpoints']('search'), {
                params: {
                    term: term,
                    includes: includes,
                    page: page,
                    perPage: perPage
                }
            });

            if (response.status === 200) {
                commit('searchPagination', response.data.meta);

                let reducedData = [];

                for (let i = 0; i < response.data.data.length; i++) {
                    reducedData.push(await dispatch('set', response.data.data[i]));
                }

                return reducedData;
            }

            return false;
        }
    }
}

export default baseModule;
